import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ['container', 'comment']
  static activeModal = null;

  open() {
    const modalElement = document.querySelector('[data-controller="remand-modal"]');
    if (modalElement){
      this.modal = new Modal(modalElement);
    }
    this.modal.show();

    this.constructor.activeModel = this.modal;
  }

  close() {
    if(this.constructor.activeModel){
      this.constructor.activeModel.hide()
      this.constructor.activeModel = null;
    }
  }

  submit(event) {
    if (this.commentTarget.value.trim().length === 0) {
      event.preventDefault()
      alert("差戻し内容が入力されていません。");
    }
  }
}
